
























































import { Component, Vue, Emit } from 'vue-property-decorator';

@Component
export default class CharTitleIcon extends Vue {
  private isTime: boolean = false;
  private isTicket: boolean = true;
  private viewIconColor(isView: boolean) {
    if (isView) {
      return '#4384f3';
    } else {
      return 'grey lighten-1';
    }
  }

  /**
   * グラフタイトルを変更する関数&&親コンポーネントのグラフ表示を切り替えるemit:boolean
   * 引数：グラフ名
   * 返り値：親コンポーネントに渡すboolean
   */
  @Emit('isChangedChartTitle')
  private changeChart(value: string): boolean | undefined {
    if (value === 'isTicket') {
      this.isTicket = true;
      this.isTime = false;
      return true;
    }
    if (value === 'isTime') {
      this.isTime = true;
      this.isTicket = false;
      return false;
    }
  }
}
